import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import './servicesDaroma.scss'
import DigitalizacionServices from './ourServices/digitalizacionServices';
import AutomatizacionServices from './ourServices/automatizacionServices';
import InteligenciaArtificialService from './ourServices/inteligenciaArtificialService';
import BusinessIntelligenceService from './ourServices/businessIntelligenceService';
import EstrategiaNegocioServices from './ourServices/estrategiaNegocioServices';
import { FaLaptopCode, FaBrain, FaChartLine, FaCogs, FaProjectDiagram } from 'react-icons/fa';

const ServicesDaroma = () => {
    const { t } = useTranslation();
    const [activeService, setActiveService] = useState('digitalizacion')
    const lineRefs = useRef([]);

    const services = [
        { id: 'digitalizacion', labelKey: 'services.daroma.digitalizationLabel', icon: <FaLaptopCode size={60} />, component: <DigitalizacionServices /> },
        { id: 'inteligencia', labelKey: 'services.daroma.aiLabel', icon: <FaBrain size={60} />, component: <InteligenciaArtificialService /> },
        { id: 'business', labelKey: 'services.daroma.biLabel', icon: <FaChartLine size={60} />, component: <BusinessIntelligenceService /> },
        { id: 'automatizaciones', labelKey: 'services.daroma.automationLabel', icon: <FaCogs size={60} />, component: <AutomatizacionServices /> },
        { id: 'estrategia', labelKey: 'services.daroma.strategyLabel', icon: <FaProjectDiagram size={60} />, component: <EstrategiaNegocioServices /> }
    ];

    useEffect(() => {
        const observerOptions = {
            threshold: 0.2,
            rootMargin: '0px 0px 0px 0px'
        };


        const lineObservers = lineRefs.current.map((lineRef) => {
            if (!lineRef) return null;

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('content__title-line--visible');
                        observer.unobserve(entry.target);
                    }
                });
            }, observerOptions);

            observer.observe(lineRef);
            return observer;
        });

        return () => {
            lineObservers.forEach(obs => obs?.disconnect());
        };
    }, []);

    const handleCardClick = (serviceId) => {
        setActiveService(prev => (prev === serviceId ? null : serviceId));
    };

    return (
        <div className="services-daroma">
            <div className="services-daroma__header ">
                <h2 className="services-daroma__title content__title-backgroundDark">
                    {t('services.daroma.title')}
                </h2>
                <div
                    ref={el => lineRefs.current[0] = el}
                    className="content__title-line"
                />
            </div>

            <div className="services-daroma__grid">
                {services.map((service) => (
                    <div
                        key={service.id}
                        onClick={() => handleCardClick(service.id)}
                    >
                        <div className={`services-daroma__card ${activeService === service.id ? 'services-daroma__card--active' : ''}`}>
                            <div className={`services-daroma__icon-container ${activeService === service.id ? 'services-daroma__icon-container--active' : ''}`}>
                                {service.icon}
                            </div>
                            <h3 className={`services-daroma__label ${activeService === service.id ? 'services-daroma__label--active' : ''}`}>{t(service.labelKey)}</h3>
                        </div>
                        <div>
                            {activeService === service.id && (
                                <div className="services-daroma__service-content1100">
                                    {service.component}
                                </div>
                            )}
                        </div>

                    </div>

                ))}
            </div>

            <div className="services-daroma__content">
                <div className="services-daroma__service-content">
                    {services.find(service => service.id === activeService)?.component}
                </div>
            </div>

        </div>
    );
};

export default ServicesDaroma;